import { capitalize } from '@as-react/common-utils';
const defaultPaddingsMap = {
    none: '0',
    xs: '2',
    sm: '4',
    md: '6',
    lg: '8',
    gutter: '4',
};
const directionToLogicalPropertyMap = {
    top: 'paddingBlockStart',
    bottom: 'paddingBlockEnd',
    left: 'paddingInlineStart',
    right: 'paddingInlineEnd',
};
export const getBoxPropsFromAEMPaddings = (paddings = {}, map = defaultPaddingsMap) => {
    const paddingDirections = Object.keys(paddings);
    return Object.values(paddings).reduce((prevValue, curValue, index) => {
        if (!curValue) {
            return prevValue;
        }
        const direction = paddingDirections[index];
        if (!direction) {
            return prevValue;
        }
        const logicalProperty = directionToLogicalPropertyMap[direction] || `padding${capitalize(direction)}`;
        const value = map[curValue];
        if (!value) {
            return prevValue;
        }
        return Object.assign(Object.assign({}, prevValue), { [logicalProperty]: value });
    }, {});
};
/**
 * Maps AEM color to Andes ColorContent.
 */
export const mapColor = (color) => {
    switch (color) {
        case 'black':
            return 'neutral';
        case 'white':
            return 'inverse';
        default:
            return undefined;
    }
};
const mapPaddingValue = (value) => {
    if (!value)
        return;
    switch (value) {
        case 'xs':
            return '2';
        case 'sm':
            return '4';
        case 'md':
            return '6';
        case 'lg':
            return '10';
        case 'gutter':
            return { base: '2', md: '4', xl: '6' };
        default:
            return undefined;
    }
};
/**
 * Maps AEMPaddings to BoxProps padding properties.
 */
export const mapPaddings = (paddings) => {
    if (!paddings)
        return {};
    return {
        paddingBlockStart: mapPaddingValue(paddings.top),
        paddingBlockEnd: mapPaddingValue(paddings.bottom),
        paddingInlineStart: mapPaddingValue(paddings.left),
        paddingInlineEnd: mapPaddingValue(paddings.right),
    };
};
/**
 * Maps AEM alignment to Andes TextAlpha alignment.
 */
export const mapAlignment = (alignment) => {
    switch (alignment) {
        case 'left':
            return 'start';
        case 'center':
            return 'center';
        case 'right':
            return 'end';
        default:
            return undefined;
    }
};
